import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { StockOutModel } from './stock-out.model';

export class StockOutResponse extends GlobalResponseObject {
    data: StockOutModel[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data: StockOutModel[]){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}